<template>
  <RouterView />
</template>

<script setup>
import { RouterView } from 'vue-router'
</script>

<style>
/* 全局滚动条样式 */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: var(--bs-primary);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: #2d3748;
}

/* 全局选择器样式 */
::selection {
  background-color: rgba(var(--bs-primary-rgb), 0.2);
  color: var(--bs-dark);
}

/* 图片响应式 */
img {
  max-width: 100%;
  height: auto;
}

/* 链接样式 */
a {
  text-decoration: none;
  transition: color 0.2s ease;
}

/* 输入框聚焦效果 */
.form-control:focus,
.form-select:focus {
  border-color: var(--bs-primary);
  box-shadow: 0 0 0 0.25rem rgba(var(--bs-primary-rgb), 0.25);
}

/* 禁用状态样式 */
:disabled {
  opacity: 0.6;
  cursor: not-allowed !important;
}
</style>
